// @flow
import existy from './existy';
import isElement from './isElement';

/* Append child node */
export default function append(parent: Node, child: Node, before: ?Node) {
   if (!parent) return;

   if (existy(before) && isElement(before)) {
      parent.insertBefore(child, before);
   } else {
      parent.appendChild(child);
   }
}
